import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { getVatDeadlines } from "../../../services/tenantUserAdminService";
import { TC } from "../../../tokens/text";

export default function VATDeadlinesWidget({ tenantId }) {
  const [loading, setLoading] = useState(true);
  const [deadlines, setDeadlines] = useState([]);

  useEffect(() => {
    const demoMode = typeof window !== 'undefined' && (window.__LEDGERHUB_DEMO || new URLSearchParams(window.location.search).get('demo') === 'true');
    if (demoMode) {
      const now = new Date();
      const d1 = new Date(now); d1.setDate(now.getDate() + 12);
      const d2 = new Date(now); d2.setDate(now.getDate() + 34);
      setDeadlines([
        { type: 'Quarterly VAT Return', date: d1.toISOString(), clientId: 'demo-a', clientName: 'Demo Ltd' },
        { type: 'VAT Payment', date: d2.toISOString(), clientId: 'demo-b', clientName: 'Acme Bakery' },
      ]);
      setLoading(false);
      return;
    }
    if (!tenantId) return;
    setLoading(true);
    getVatDeadlines(tenantId)
      .then((res) => setDeadlines(res.deadlines || []))
      .catch(() => setDeadlines([]))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return <VuiBox display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress size={24} /></VuiBox>;
  if (!deadlines.length) return <VuiBox p={2}><VuiTypography color="text">No upcoming VAT or tax deadlines.</VuiTypography></VuiBox>;

  return (
    <VuiBox p={1} display="flex" flexDirection="column" gap={1}>
      {deadlines.map((d) => (
        <VuiBox key={d.type+d.date} display="flex" justifyContent="space-between" sx={{ p: 1, background: "#f4f8ff", borderRadius: 1 }}>
          <VuiTypography sx={{ color: TC.secondary }}>{d.type}</VuiTypography>
          <VuiTypography sx={{ color: TC.primary, fontWeight: 700 }}>{new Date(d.date).toLocaleDateString()}</VuiTypography>
        </VuiBox>
      ))}
    </VuiBox>
  );
}

